import type { ReactNode } from 'react';
import './InputRow.css';

export type InputRowProps = {
  input: ReactNode;
  action?: ReactNode;
  className?: string;
};

export function InputRow({ input, action, className = '' }: InputRowProps) {
  return (
    <div className={`input-row ${className}`.trim()}>
      <div className="input-row__input">{input}</div>
      {action && <div className="input-row__action">{action}</div>}
    </div>
  );
}
